import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { SiteLanguage } from '../seo/constants';
import { resolveLocalizationRequest } from '../localization/middleware/resolveLocalizationRequest';

type LocaleShellProps = {
  lang: SiteLanguage;
};

/**
 * Dil önekli rota kabuğu — URL dilini i18next ve localization ile senkronize eder.
 */
export default function LocaleShell({ lang }: LocaleShellProps) {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== lang) {
      void i18n.changeLanguage(lang);
    }
    resolveLocalizationRequest({ language: lang });
  }, [lang, i18n]);

  return <Outlet />;
}
